import { faHeading } from "@fortawesome/free-solid-svg-icons";
import { QuestionDefinition, QuestionProps } from "../QuestionAnswer";

export const TitleQuestionDefinition: QuestionDefinition = {
    icon: faHeading,
    defaultOptions: {},
    questionComponent: TitleQuestion,
};

function TitleQuestion(props: QuestionProps<{}, {}>) {
    return null;
}
